export const EVALUATIONS_COMPLETED = "Surveys Completed";



// WEBPACK FOOTER //
// ./src/features/director/pages/dashboard/components/sport-table/constants.ts